__turbopack_context__.v({
  "className": "roboto_condensed_f0e66527-module__sLexQq__className",
  "variable": "roboto_condensed_f0e66527-module__sLexQq__variable",
});
